@import '~style-sheet-helpers/core.less';

.simple-dropdown {
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: 10px;
  font-size: 14px;

  .simple-dropdown-menu button:disabled {
    background-color: var(--grey-200);
  }
}

.simple-dropdown-full-width {
  width: 100%;
}

.simple-dropdown-without-label {
  grid-template-columns: 1fr auto;
}

.simple-dropdown-label {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
}

.simple-dropdown-menu {
  width: 100%;
}
